import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LegalLayout = ({ title, eyebrow, lastUpdate, children, testid }) => {
  return (
    <main className="min-h-screen bg-cream text-lava" data-testid={testid}>
      <header className="bg-cream/85 backdrop-blur-xl border-b border-lava/10 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-5 md:px-12 h-16 md:h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="flex items-center gap-3 group"
          >
            <span className="w-9 h-9 bg-lava text-cream flex items-center justify-center font-display text-base font-medium tracking-tight">
              MG
            </span>
            <span className="hidden sm:flex flex-col leading-none">
              <span className="font-display text-base tracking-tight font-medium">
                Pantelflora S.N.C.
              </span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-lava/55 mt-1 font-mono">
                Giardiniere · Pantelleria
              </span>
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm tracking-tight text-lava/70 hover:text-lava transition-colors group"
          >
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" />
            Torna alla home
          </Link>
        </div>
      </header>

      <article className="max-w-4xl mx-auto px-5 md:px-12 py-16 md:py-24 pb-32 md:pb-40">
        <div className="flex items-center gap-3 mb-5">
          <span className="w-2 h-2 bg-terracotta" />
          <span className="text-[11px] uppercase tracking-[0.25em] text-terracotta font-mono">
            {eyebrow}
          </span>
        </div>
        <h1
          data-testid="legal-title"
          className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-[-0.04em] font-extralight text-lava"
        >
          {title}
        </h1>
        {lastUpdate && (
          <p className="mt-5 text-xs font-mono uppercase tracking-[0.2em] text-lava/55">
            Ultimo aggiornamento: {lastUpdate}
          </p>
        )}

        <div className="mt-10 md:mt-14 prose-legal max-w-none text-lava/85 font-light leading-relaxed text-base">
          {children}
        </div>

        <div className="mt-16 pt-8 border-t border-lava/15 flex flex-col md:flex-row gap-5 md:gap-4 md:items-center justify-between text-[10px] uppercase tracking-[0.2em] text-lava/55 font-mono">
          <span>© {new Date().getFullYear()} Pantelflora S.N.C. — P.IVA IT01656050810</span>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link
              to="/privacy"
              className="hover:text-lava transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookie-policy"
              className="hover:text-lava transition-colors"
            >
              Cookie Policy
            </Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new CustomEvent("open-cookie-banner"))}
              className="hover:text-lava transition-colors uppercase tracking-[0.2em] cursor-pointer"
            >
              Preferenze cookie
            </button>
            <span className="opacity-70">
              Site by Pantelflora S.N.C.
            </span>
          </div>
        </div>
      </article>
    </main>
  );
};

export default LegalLayout;
